import { onScopeDispose, getCurrentScope } from 'vue';
export function tryOnScopeDispose(fn) {
  if (getCurrentScope()) {
    onScopeDispose(fn);
    return true;
  }
  return false;
}
export function resolveRef(r) {
  return typeof r === 'function' ? computed(r) : ref(r);
}
export function resolveUnref(r) {
  return typeof r === 'function' ? r() : unref(r);
}
export function unrefElement(elRef) {
  var _a;
  var plain = resolveUnref(elRef);
  return (_a = plain == null ? undefined : plain.$el) != null ? _a : plain;
}